import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=7a39e15c&scoped=true&"
import script from "./newslist.vue?vue&type=script&lang=js&"
export * from "./newslist.vue?vue&type=script&lang=js&"
import style0 from "./newslist.vue?vue&type=style&index=0&id=7a39e15c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39e15c",
  null
  
)

export default component.exports